<div class="modal-header">
    <div class="row col-12">        
        <div class="modal-title col-10">
            <h4>Opret regnskab for {{ customer.name }} - {{ customer.departmentName}} [{{customer.departmentCode}}] </h4>
        </div>
         <div class="text-end col-2">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true" ><i class="fa-solid fa-x"></i></span>
                </button>    
         </div>
    </div>
</div>

<div class="modal-body col-12">

@if (saveingCompany == true)
{

    <div class="d-flex flex-column justify-content-center align-items-center w-100 vh-50">
        <div class="continuous-loader" role="status"></div>
        <h4 class="mt-2">Gemmer regnskab</h4>
    </div>
}
@else {

    <div class="row">
            <form action="">
                <div class="row mb-3">
                    <div class="form-floating col-lg-12 col-12 mb-lg-12 mb-3">
                        @if (formLoading == true) {
                            <div class="form-control text-center">
                                <i class="fa-solid fa-spinner-third fa-spin"></i>
                            </div>
                        } 
                        @else   
                        {
                            <select class="form-select" id="createcompany-template" placeholder="Skabelon"
                                (change)="setValuesFromTemplate($event)">
                                @for (template of templates; track $index) {
                                    <option 
                                         [selected]="inputTemplateId == $index"
                                         [value]="$index"> {{ setTemplateText(template)  }} 
                                    </option>
                                }
                            </select>
                            <label class="ms-2" for="consultant-kunde">Regnskabsskabelon</label>
                        }
                    </div>                    
                </div>
                <!-- <h5 class="card-title mb-3">Kundeinfo</h5> -->
                <div class="row mb-3">
                    <div class="form-floating col-lg-12 col-12 mb-lg-12 mb-3">
                        <input type="text" class="form-control" id="company-name" [ngModel]="inputCompanyName" (ngModelChange)="onNameChanged($event)" name="regnskabsnavn" autocomplete="off" autofocus>
                        <label class="ms-2" for="customer-name">Regnskabsnavn</label>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="form-floating col-lg-12 col-12 mb-lg-12 mb-3">
                        <input type="text" class="form-control" id="company-name-url" [ngModel]="inputCompanyNameUrl" (ngModelChange)="onUrlChanged($event)" name="regnskabsnavnurl" autocomplete="off">
                        <label class="ms-2" for="customer-name">Regnskabsnavn (Url)</label>
                    </div>
                    <small class="text-muted ms-2">Url: {{ encodedNameUrl }}</small>
                </div>
            </form>
    </div>
    
    @if(companies.length > 0) 
    {
        <div class="row mb-3">
            <div class="col-12 ">
                <h5>Regnskaber:</h5>
            </div>
            <div class="table-wrap-15vh mt-2">
                <table class="table table-hover table-striped">
                    <thead class="thead-sticky">
                        <tr>
                            <th scope="col">Navn</th>
                            <th scope="col">Navn (url)</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of companies; track $index) 
                        {
                            <tr>
                                <td scope="row">{{ item.name }}</td> 
                                <td scope="row">{{ item.nameUrl }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    }
    <div class="modal-footer bg-transparent">
        <button class="btn btn-success float-end" [disabled]="! canSave()" (click)="saveCompany()" >Opret regnskab</button>
    </div>
}
</div>

